import { __assign, __rest } from "tslib";
import React from 'react';
import PropTypes from 'prop-types';
import Portal from './Portal';
import ModalHeader from './Modal.Header';
import Form from './Form';
import ModalBody from './Modal.Body';
import ModalFooter from './Modal.Footer';
import oneOfComponentType from '../propTypes/oneOfComponentType';
var Modal = function (_a) {
    var children = _a.children, isOpen = _a.isOpen, onClose = _a.onClose, size = _a.size, subTitle = _a.subTitle, title = _a.title, props = __rest(_a, ["children", "isOpen", "onClose", "size", "subTitle", "title"]);
    return (React.createElement(Portal, __assign({}, props, { isOpen: isOpen, type: size }),
        React.createElement(ModalHeader, { onClose: onClose, subTitle: subTitle, title: title }),
        children));
};
Modal.Body = ModalBody;
Modal.Footer = ModalFooter;
Modal.defaultProps = {
    isOpen: false,
    size: 'large'
};
Modal.propTypes = {
    children: oneOfComponentType([ModalBody, ModalFooter, Form]).isRequired,
    isOpen: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
    role: PropTypes.oneOf(['dialog']),
    size: PropTypes.oneOf(['small', 'large']),
    subTitle: PropTypes.node,
    title: PropTypes.string.isRequired
};
export default Modal;
//# sourceMappingURL=Modal.js.map